import { SigilMark } from "./Sigil";
import { scrollToSection } from "./Navbar";

export const Footer = () => (
  <footer
    data-testid="footer"
    className="relative bg-[#070608] border-t border-gold/20 pt-20 pb-10 overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative z-10">
      <div className="grid md:grid-cols-3 gap-12 mb-16">
        <div>
          <div className="flex items-center gap-3 text-gold mb-5">
            <SigilMark className="w-8 h-8" />
            <span className="font-display tracking-[0.22em] text-sm text-parchment">
              PRISCA ARCANA
            </span>
          </div>
          <p className="text-sm text-parchment-muted leading-relaxed max-w-xs">
            Ancient esoteric knowledge for modern harmony, wealth and vitality.
            Preserving the grimoire traditions with reverence and craft.
          </p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] font-mono text-gold/70 mb-5">
            Navigate
          </p>
          <div className="flex flex-col gap-3">
            {[
              ["Services", "services"],
              ["Grimoires", "grimoires"],
              ["Whispers", "testimonials"],
              ["Pricing", "pricing"],
              ["Enquiry", "enquiry"],
            ].map(([label, id]) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToSection(id)}
                className="text-left text-sm text-parchment-muted hover:text-gold transition-colors w-fit"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] font-mono text-gold/70 mb-5">
            Notice
          </p>
          <p className="text-xs text-parchment-muted/80 leading-relaxed max-w-xs">
            All workings are offered as spiritual guidance and traditional practice.
            They complement — never replace — professional medical, legal or
            financial counsel. Results follow the will of the stars and the
            sincerity of the seeker.
          </p>
          <p className="mt-4 text-xs text-gold/70 font-mono tracking-wider">
            Secured by Razorpay · 256-bit encryption
          </p>
        </div>
      </div>

      <div className="border-t border-gold/10 pt-8 flex flex-col sm:flex-row justify-between gap-3 text-[11px] font-mono tracking-wider text-parchment-muted/60">
        <span>© {new Date().getFullYear()} Prisca Arcana · All rites reserved</span>
        <span>Ancient Knowledge Preservation Circle</span>
      </div>
    </div>

    <div
      aria-hidden="true"
      className="pointer-events-none select-none absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap font-display text-[18vw] leading-none text-gold/[0.04]"
    >
      ARCANA
    </div>
  </footer>
);
